function capitalizeFirstLetter([ first, ...rest ]) {
  return [ first.toUpperCase(), ...rest ].join('');
}

export default class FilterSet {
  constructor() {
    this.state = []
    this.getters = {}
    this.actions = {}
    this.mutations = {}
  } 

  addFilter(name, initialValue) {
    const propertyName = `${name}Filters`
    const mutationName = `SET_${name.toUpperCase()}_FILTERS`
    const capName = capitalizeFirstLetter(propertyName)

    // STATE
    this.state.push(
      () => {
        let result = {}
        result[propertyName] = null
        return result
      }
    )

    // GETTERS
    this.getters[propertyName] = state => state[propertyName]

    // ACTIONS
    this.actions[`load${capName}`] = ({ commit, state }) => {
      if (state[propertyName])
        return false

      const filtersRaw = localStorage.getItem(propertyName)
      const newFilters = filtersRaw ? JSON.parse(filtersRaw) : initialValue
      
      commit(mutationName, newFilters)
      
      return true
    }

    this.actions[`update${capName}`] = ({ commit }, filters) => {
      localStorage.setItem(propertyName, JSON.stringify(filters))
      commit(mutationName, filters)
    }

    this.actions[`clear${capName}`] = ({ commit }) => {
      localStorage.setItem(propertyName, JSON.stringify(initialValue))
      commit(mutationName, initialValue)
    }

    // MUTATIONS
    this.mutations[mutationName] = (state, filters) => state[propertyName] = filters
  }

  getModule() {
    const state = () => Object.assign({}, ...this.state.map( f => f() ))

    return {
      namespaced: true,
      state,
      getters: this.getters,
      actions: this.actions,
      mutations: this.mutations,
    }
  }
}